/**
 * @flow
 * @relayHash f2c7633e6faa59a908bfd829c37f8879
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SourceAttributionInput = {|
  guestUserId?: ?string,
  landingPage?: ?string,
  type: string,
  userId: string,
  userToken?: ?string,
  emailToken?: ?string,
  visitCount?: ?number,
  pageVisits?: ?$ReadOnlyArray<?pageVisits>,
  clientMutationId?: ?string,
|};
export type pageVisits = {|
  date?: ?string,
  type?: ?string,
  utmParams?: ?utmParams,
|};
export type utmParams = {|
  landingPage?: ?string,
  visitCount?: ?number,
|};
export type sourceAttributionMutationVariables = {|
  input: SourceAttributionInput
|};
export type sourceAttributionMutationResponse = {|
  +sourceAttribution: ?{|
    +message: ?string
  |}
|};
export type sourceAttributionMutation = {|
  variables: sourceAttributionMutationVariables,
  response: sourceAttributionMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SourceAttributionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sourceAttribution",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SourceAttributionInput!"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sourceAttributionMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "sourceAttributionMutation",
    "id": "dibs-buyer-layout/209.2.8-2019-03-25T20:56:18.750Z/sourceAttributionMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0776fc099f129d46b7995c62aa8613ee';
module.exports = node;
